import React, { useMemo } from 'react';
import { ListGroup, ListGroupItem, CardBody } from 'reactstrap';

const GetAndSelectNotes = ({ initialNotes = [] }) => {
 // Group notes by category
 const groupedNotes = useMemo(() => {
   return initialNotes.reduce((acc, note) => {
     if (!acc[note.category]) {
       acc[note.category] = [];
     }
     acc[note.category].push(note);
     return acc;
   }, {});
 }, [initialNotes]);

 return (
   <CardBody className="p-4 border-top border-top-dashed">
     <div className="mb-3">
       <h5 className="text-muted text-uppercase fw-semibold mb-0">Teklif Notları</h5>
     </div>

     <div className="selected-notes">
       {Object.entries(groupedNotes).length > 0 ? (
         Object.entries(groupedNotes).map(([category, notes]) => (
           <div key={category} className="mb-4">
             <h6 className="mb-3 fw-semibold text-uppercase">{category}</h6>
             <ListGroup>
               {notes.map((note) => (
                 <ListGroupItem 
                   key={note.key}
                   className="px-0 border-0"
                 >
                   <div className="d-flex">
                     <div className="flex-shrink-0 me-3">
                       <i className="ri-checkbox-circle-fill text-success"></i>
                     </div>
                     <div className="flex-grow-1">
                       <p className="text-muted mb-0">{note.text}</p>
                     </div>
                   </div>
                 </ListGroupItem>
               ))}
             </ListGroup>
           </div>
         ))
       ) : (
         <div className="text-center text-muted p-4 border rounded">
           <p className="mb-0">Not bulunamadı</p>
         </div>
       )}
     </div>
   </CardBody>
 );
};

export default GetAndSelectNotes;